/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are emoji handled?`)
};

const es_ci_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se manejan los emoji?`)
};

const de_ci_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie werden Emojis behandelt?`)
};

const nl_ci_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe worden emoji's verwerkt?`)
};

const fr_ci_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment les emoji sont-ils gérés ?`)
};

const it_ci_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vengono gestiti gli emoji?`)
};

const pt_br2_ci_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como os emoji são tratados?`)
};

const pt_ci_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como são tratados os emoji?`)
};

const ja_ci_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「絵文字はどのように処理されますか?」`)
};

const zh_ci_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表情符号是如何处理的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_faq1_q", locale)
	if (locale === "en") return en_ci_faq1_q(inputs)
	if (locale === "es") return es_ci_faq1_q(inputs)
	if (locale === "de") return de_ci_faq1_q(inputs)
	if (locale === "nl") return nl_ci_faq1_q(inputs)
	if (locale === "fr") return fr_ci_faq1_q(inputs)
	if (locale === "it") return it_ci_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_ci_faq1_q(inputs)
	if (locale === "pt") return pt_ci_faq1_q(inputs)
	if (locale === "ja") return ja_ci_faq1_q(inputs)
	return zh_ci_faq1_q(inputs)
};